<template>
  <c-view>
    <c-page>
      <c-content>
        <div class="logo"></div>
        <c-msg title="恭喜您，注册成功" :desc="desc.join('<br>')">
          <c-button @click.native="downloadApp">
            下载生意专家手机端
          </c-button>
        </c-msg>
        <info-footer></info-footer>
      </c-content>
    </c-page>
  </c-view>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>
<script>
  import InfoFooter from '../info-footer'

  export default {
    data () {
      return {
        desc: ['立即下载生意专家手机端，', '或用电脑登录www.i200.cn', '查看完整功能或体验行业版！']
      }
    },
    components: {InfoFooter},
    created () {
    },
    mounted () {
    },
    beforeDestroy () {
    },
    methods: {
      downloadApp () {
        location.href = 'http://www.i200.cn/Download.aspx?from=newmobilepage2017'
      }
    },
    computed: {},
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?2f2c1bb6